import { createStore } from 'zustand/vanilla'

export type NotificationState = {
  productId: string
  notificationId?: string
  price: number
  priceLowest: number
  open?: boolean
  dialogOpen?: boolean
}

export type NotificationActions = {
  onOpenChange: (open: boolean) => void
  onClickDrawer: (
    notifiedStatus?: 'notified' | 'unNotified' | 'loading',
  ) => (notificationOptions: NotificationState) => void
  onChangeNotificationId: ({
    notificationId,
  }: {
    notificationId: NotificationState['notificationId']
  }) => void
  onOpenDialogChange: (dialogOpen: boolean) => void
}

export type NotificationStore = NotificationState & NotificationActions

export const defaultInitState: NotificationState = {
  productId: '',
  notificationId: '',
  price: 0,
  priceLowest: 0,
  open: false,
  dialogOpen: false,
}

export const createNotificationStore = (
  initState: NotificationState = defaultInitState,
) => {
  return createStore<NotificationStore>()((set) => ({
    ...initState,
    onClickDrawer: (
      notifiedStatus: 'loading' | 'notified' | 'unNotified' = 'unNotified',
    ) =>
      notifiedStatus !== 'loading' && notifiedStatus === 'unNotified'
        ? (notificationOptions: Omit<NotificationState, 'open'>) =>
            set((state) => ({ ...notificationOptions, open: !state.open }))
        : (notificationOptions: Omit<NotificationState, 'open'>) =>
            set((state) => ({
              ...notificationOptions,
              dialogOpen: !state.dialogOpen,
            })),
    onOpenChange: (open: boolean) => set(() => ({ open })),
    onOpenDialogChange: (dialogOpen: boolean) => set(() => ({ dialogOpen })),
    onChangeNotificationId: ({ notificationId }) =>
      set(() => ({ notificationId })),
  }))
}
